/* @flow */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../../../utilities/currency';

type Props = {
  netTotal: number,
};

export const NetExpectedIncome = ({ netTotal }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="ds-l-row ds-u-padding-y--3 ds-u-border-top--2 ds-u-border--dark">
      <div className="ds-l-md-col--12">
        <h2 className="ds-h2 ds-u-justify-content--between ds-u-display--flex">
          <span>{t('expectedYearlyIncome')}</span>
          <span>{formatCurrency(netTotal)}</span>
        </h2>
      </div>
    </div>
  );
};

export default NetExpectedIncome;
